<template>
  <div class="addproject-step1">
    <div class="profile-item-title">Введите название проекта</div>
    <div class="profile-item-value">
      <v-text-field :value="curProject.name" @input="onInput('name', $event)"
          :error-messages="fieldErrors('name')" outlined dense _hide-details
        />
    </div>
    <div class="profile-item-title">Краткое описание проекта</div>
    <div class="profile-item-value">
      <v-textarea :value="curProject.description" @input="onInput('description', $event)"
          :error-messages="fieldErrors('description')" outlined dense no-resize _hide-details rows="3"
        />
    </div>

    <div class="profile-item-title">Продолжительность проекта</div>
    <div class="profile-item-value">
      <v-menu v-model="datePickerShow" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value="range.join(' - ')"
            append-icon="mdi-calendar" :prepend-inner-icon="range.length ? 'mdi-close' : null"
            @click:prepend-inner="clearRange"
            class="project-range font-sm" dense readonly outlined hide-details
            v-bind="attrs" v-on="on"
          />
        </template>
        <v-date-picker v-model="range" dense range no-title scrollable locale="ru-RU">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="cancelRange"> Отменить </v-btn>
          <v-btn text color="primary" @click="applyRange" :disabled="range.length !== 2"> OK </v-btn>
        </v-date-picker>
      </v-menu>
    </div>

    <div v-if="!hideControls" class="d-flex justify-end mt-8 mb-3" >
      <v-btn @click="next()" color="primary" class="px-13">Далее</v-btn>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from 'vuex';
import AIMainPage from '@/components/ai/AIMainPage.vue';

export default {
  name: 'AIPage',
  components: {
    AIMainPage
  },
  props:{
    hideControls: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      datePickerShow: false,
      datePickerDateFormat: 'DD-MM-YYYY',
      range: [],
    };
  },
  computed: {
    ...mapGetters({
      curProject: 'ai/hrprojects/curProject',
      loading: 'ai/hrprojects/loading',
    }),
  },
  methods: {
    onInput() {

    },
    fieldErrors() {

    },
    clearRange() {
      this.range = [];
      this.datePickerShow = false;
    },
    cancelRange() {
      if (this.curProject.date_from && this.curProject.date_to) {
        this.range = [this.curProject.date_from, this.curProject.date_to];
      } else {
        this.range = [];
      }
      this.datePickerShow = false;
    },
    applyRange() {
      this.range = this.range.sort((a, b) =>
        this.$moment(a, this.datePickerDateFormat).isBefore(this.$moment(b, this.datePickerDateFormat)) ? -1 : 1
      );
      // this.setFilterRange(this.range);
      this.datePickerShow = false;
    },
    next() {
      this.$emit('next')
    },
  }
};
</script>

<style lang="scss" scoped>

.addproject-step1 {
  width: 800px;
  max-width: 100%;
}

.project-range {
  width: 300px; 
  max-width: 100%;

}
</style>

